import { withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["contenteditable"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      contenteditable: _ctx.textSize,
      id: "message",
      class: "textarea border-2 border-gray-200 rounded-md",
      "data-text": "",
      onKeyup: _cache[0] || (_cache[0] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onGetMessage && _ctx.onGetMessage(...args)), ["prevent"]), ["enter"]))
    }, null, 40, _hoisted_1),
    (!_ctx.recorded)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onStartRecord && _ctx.onStartRecord(...args))),
          class: "btn-simple w-10",
          title: "aperte o botão para gravar um áudio"
        }, [
          _createVNode(_component_v_icon, {
            name: "hi-solid-microphone",
            class: "text-primary-400"
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.recorded)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onRecordStop && _ctx.onRecordStop(...args))),
          class: "btn-simple w-10",
          title: "aperte o botão para parar gravação"
        }, [
          _createVNode(_component_v_icon, {
            name: "md-stopcircle-outlined",
            class: "text-h-error-400 animate-pulse",
            scale: 1.5
          }, null, 8, ["scale"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "btn-simple w-10",
      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onGetMessage && _ctx.onGetMessage(...args)), ["prevent"]))
    }, [
      _createVNode(_component_v_icon, {
        name: "md-send-sharp",
        class: "text-primary-400"
      })
    ])
  ], 64))
}